import GQLClient from './GQLClient';
import ky from 'ky';

const gql = new GQLClient(window.sbvrenv.API_URL, ky);

export { gql };
